
import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "@/components/main-header.vue";
import { GetContentDetail, EditContent } from "@/request/common";
import Report from "@/components/template-transfer-pc/report/report.vue";
@Component({
  components: {
    MainHeader,
    Report,
  },
})
export default class Name extends Vue {
  private ifEdit: any = false;
  private data: any = [];
  private multiple: any = false; // 是否是批量打印报告
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private changeData(e: any, index: any) {
    this.data[index].data = e;
    this.$forceUpdate();
  }
  private save() {
    this.data.forEach((ele: any) => {
      const params: any = {
        report: ele.data.report,
      };
      EditContent(this, ele.id, params).then(() => {});
    });
    this.ifEdit = false;
  }
  private getData() {
    this.data.forEach((ele: any) => {
      GetContentDetail(this, ele.id).then((res: any) => {
        ele.data = res.data;
        this.$forceUpdate();
      });
    });
    console.log("数据");
    console.log(this.data);
  }
  private mounted() {
    if (this.$route.query.ids) {
      const ids: any = JSON.parse(this.$route.query.ids as any);
      this.data = [];
      ids.forEach((ele: any) => {
        const obj: any = {
          id: ele,
          data: {},
        };
        this.data.push(obj);
      });
      this.getData();
    }
  }
}
